const $ = require('jquery')

// =========================================================================
// Offers
// =========================================================================
const OFFERS = {
  /**
   * @name OFFERS.ellipsisInOfferItem - Ellipsis for offer item
   * @return {Boolean}
   */
  ellipsisInOfferItem () {
    $('.offer-list-item__wrapper .tooltip-wrapper .custom-tooltip').each(function() {
      $(this).ellipsis('.custom-tooltip', {
        live: true,
      })
    })
  },
}

module.exports = OFFERS



// WEBPACK FOOTER //
// ./src/modules/offers.js